import { render, staticRenderFns } from "./PersonAnnotationHistoryMedia.vue?vue&type=template&id=522e0afc&"
import script from "./PersonAnnotationHistoryMedia.vue?vue&type=script&lang=ts&"
export * from "./PersonAnnotationHistoryMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCol,VImg})
